<template>
  <div class="expand-row-btn__wrapper">
    <v-progress-circular
      v-if="isLoading"
      size="25"
      width="3"
      indeterminate
      color="primary"
    />
    <v-icon @click="expand(!isExpanded)" v-else>
      {{ isExpanded ? "mdi-menu-down" : "mdi-menu-right" }}
    </v-icon>
  </div>
</template>

<script>
/**
 * Expand row btn for expandable rows in data tables
 * @author {Jatin Kamboj}
 */
export default {
  name: "ExpandRowBtn",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    isLoading: { type: Boolean, default: false, required: true },
    isExpanded: { type: Boolean, default: false, required: true },
    expand: { type: Function, default: () => {}, required: true },
  },
};
</script>
